import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { color } from '../../app/theme';
import Mask from './SettingBarMask';
import Time from './conditionSetting/Time';
import Type from './conditionSetting/Type';
import ClickType from './conditionSetting/ClickType';
import Branch from './conditionSetting/Branch';
import Sticker from './conditionSetting/Sticker';
import MessageContent from './conditionSetting/MessageContent';
import { ConditionsClickType, ConditionsType } from '../../app/types';
import isSun from '../../assets/images/svg/ic-sun.svg';

const useStyles = makeStyles(
  {
    top: {
      fontSize: '17px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      background: color.$9,
      textAlign: 'center',
      padding: '18px 0 21px',
    },
    bottom: {
      padding: '24px 16px',
      overflowY: 'auto',
      height: 'calc(100vh - 170px)',
    },
    hr: {
      padding: 0,
      width: '100%',
      height: 1,
      background: color.$9,
      margin: '36px 0',
    },
    sun: {
      marginTop: 24,
      display: 'flex',
      alignItems: 'center',
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$7,
      background: color.$15,
      width: 80,
      borderRadius: '20px',
      justifyContent: 'center',
      padding: '2px 0',
      marginBottom: 6,
    },
    hint: {
      fontSize: '13px',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: color.$13,
      marginBottom: 24,
    },
  },
  {
    name: 'ConditionSetting',
  },
);

const ConditionSetting = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { clickType, type } = selectedNode?.data;

  return (
    <>
      <div className={classes.top}>{t('add-conditions')}</div>
      <div id="condition-setting-bar-bottom" className={classes.bottom}>
        <Time />
        <hr className={classes.hr} />
        <Type />
        {type === ConditionsType.CLICK && (
          <>
            <ClickType />
            {clickType === ConditionsClickType.BUTTON && <Branch />}
            {clickType === ConditionsClickType.ANY && (
              <>
                <div className={classes.sun}>
                  <img src={isSun} alt="minus" />
                  {t('trigger-setting.sun')}
                </div>
                <div className={classes.hint}>
                  {t('condition-setting.any-hint')}
                </div>
              </>
            )}
            <MessageContent />
          </>
        )}
        {type === ConditionsType.STICKER && <Sticker />}
      </div>
      <Mask mainId="condition-setting-bar-bottom" />
    </>
  );
};

export default ConditionSetting;
